import script from "./StrategyTemplateModal.vue?vue&type=script&setup=true&lang=js"
export * from "./StrategyTemplateModal.vue?vue&type=script&setup=true&lang=js"

import "./StrategyTemplateModal.vue?vue&type=style&index=0&id=22b7b8e0&lang=less&scoped=true"

import exportComponent from "/Users/timetravel/code/energy-storage-intelligence/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22b7b8e0"]])

export default __exports__